import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';

interface NavbarProps {
  onClickContactUS: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onClickContactUS }) => {
  const { t } = useTranslation();
  const logoURL = "https://www.surveyfoods.com/public/assets/logos/orange_bg_logo.jpeg";

  const handleSignInClick = () => {
    window.open('https://app.surveyfoods.com', '_blank');
  };

  return (
    <div className='bg-slate-50 shadow-md border-b border-slate-200 sticky top-0 z-50 backdrop-blur-sm bg-slate-50/95'>
      <div className='flex justify-between items-center h-16 md:h-20 lg:h-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full'>
        {/* Logo */}
        <div className="flex items-center">
          <img 
            src={logoURL} 
            alt="Survey Foods Logo" 
            className="h-8 md:h-10 lg:h-12 w-auto min-w-[80px] max-w-[200px] md:max-w-[250px] lg:max-w-[300px] cursor-pointer hover:opacity-90 transition-opacity duration-300" 
          />
        </div>

        {/* Navigation Links */}
        <div className="flex items-center space-x-2 md:space-x-4">
          {/* Sign In Link */}
          <button
            onClick={handleSignInClick}
            className='group flex items-center px-3 md:px-4 py-2 md:py-2.5 font-medium text-sm md:text-base text-slate-600 hover:text-slate-800 border border-slate-300 hover:border-slate-400 rounded-lg transition-all duration-300 hover:bg-white/80'
          >
            <span>{t('navbar.signIn')}</span>
            <ExternalLink className="w-3 h-3 md:w-4 md:h-4 ml-1.5 md:ml-2 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
          </button>

          {/* Contact Us Button */}
          <button
            className='px-4 md:px-6 lg:px-8 py-2 md:py-3 lg:py-4 font-semibold text-sm md:text-base lg:text-lg bg-[#f84831] text-white rounded-lg md:rounded-xl hover:bg-[#e63e26] transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl'
            onClick={onClickContactUS}
          >
            {t('navbar.contactUs')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
